/** @jsxImportSource react */
import Accordian from '@react/profile/v2/Accordian';
import VerifiedMoves from '@react/search/components/VerifiedMoves';
import { MoveIn } from '@sly/core/types';

interface ReviewsSectionProps {
  moveIns: MoveIn[];
  title: string;
  accordionTitle: string;
}

const MovesSection = ({
  title,
  moveIns,
  accordionTitle,
}: ReviewsSectionProps) => {
  return (
    <div>
      <h2 className='font-t-l mb-6'>{title}</h2>
      <Accordian
        title={accordionTitle}
        variant='A'
        eventProps={{
          location: 'verified moves table',
        }}
        openByDefault={false}
      >
        <VerifiedMoves moveIns={moveIns} />
      </Accordian>
    </div>
  );
};

export default MovesSection;
